import * as React from 'react'
import { Link, BrowserRouter, Route, Switch } from 'react-router-dom'
import { Box, Button, Stack } from '@chakra-ui/react'
import { Recipes } from '../recipes/Recipes'
import { Admin } from '../admin/Admin'
import { LogoutButton } from '../../auth/AuthButtons'
import { useGetUser } from '../../common/hooks/useGetUser'
import { Loading } from '../../common/components/Loading'
import { Error } from '../../common/components/Error'
import { FamilySelection } from './FamilySelection'
import { Header } from '../../common/components/Header'

export const Authenticated = () => {
  const { familyId, isFamilyAdmin } = useGetUser()

  if (familyId === -1) {
    return <Loading />
  }

  if (familyId === -2) {
    return <Error />
  }

  if (familyId === 0) {
    return <FamilySelection />
  }

  return (
    <BrowserRouter>
      <Header>
        <Stack direction="row" spacing={4}>
          <Link to="/recipes">
            <Button>Recipes</Button>
          </Link>
          <Link to="/schedule">
            <Button>Schedule</Button>
          </Link>
          {isFamilyAdmin && (
            <Link to="/admin">
              <Button>Admin</Button>
            </Link>
          )}
          <LogoutButton />
        </Stack>
      </Header>
      <Box w="100%" p={2}>
        <Switch>
          <Route path="/recipes" render={() => <Recipes />} />
          <Route
            path="/schedule"
            render={(props) => {
              return <div>Schedule</div>
            }}
          />
          {isFamilyAdmin && <Route path="/admin" render={() => <Admin />} />}
        </Switch>
      </Box>
    </BrowserRouter>
  )
}
